import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
const language = window.sessionStorage.getItem('language') || 'en';
import { appConfig } from './config/app-config';
i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'es-US', 'es-MX'],
    fallbackLng: 'en',
    lng: language,
    detection: {
      order: [
        'path',
        'cookie',
        'htmlTag',
        'localStorage',
        'sessionStorage',
        'navigator',
        'querystring',
        'subdomain',
      ],
      caches: ['cookie'],
    },
    backend: {
      loadPath: `${appConfig.microUrl}/am/Translation/{{lng}}/{{ns}}.json`,
    },
    ns: ['customerInfo', 'pastduelist', 'priyorityFieldVisit', 'halfwayletter'], // List your namespaces here
    defaultNS: 'customerInfo', // Default namespace to use when not specifying a namespace in your code
    react: {
      useSuspense: false,
    },
  });

export default i18n;
